module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaBAMAAABbZFH9AAAALVBMVEUAAACZmZmampqbm5uZmZmenp6ZmZmfn5+qqqqZmZmampqbm5uampqfn5+amprpV03rAAAAD3RSTlMA/pxK3R3pEAilkmNMJbMWZqKZAAAAiklEQVQY00XOsRGCQBhE4R0dR9MfAxMD7QBKsAc7MKEAMxNbcMYCtARaoAIiYkqBm3d7bLbzJU/bWt5rUFP57G6tmrjkd49Wm6hMUUvXBaGjBJpAE2gCISNk/CYqGBD7xFlaCx1ERhCUqQddSJALqYUIMhFUCDQZn4ky/tQlynjS+JD3n3R4l7fXDKA0FzdhGHJOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/runtime/images/magic/close-icon3.png
// module id = P4e2
// module chunks = 1